var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearchi = function SvgSearchi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 1570"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "data-name": "search icon"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 4861"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5A5.5 5.5 0 1 1 5.5 11 5.5 5.5 0 0 1 11 5.5"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M11 7.3c-2.04 0-3.7 1.66-3.7 3.7s1.66 3.7 3.7 3.7 3.7-1.66 3.7-3.7-1.66-3.7-3.7-3.7m0-1.8a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: props.color || 'currentColor',
    strokeLinecap: "round",
    strokeWidth: 1.8,
    d: "m18.5 18.5-4-4",
    "data-name": "Path 4556"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearchi);
export default ForwardRef;